import { render, staticRenderFns } from "./UserExplain.vue?vue&type=template&id=98136f86&scoped=true"
import script from "./UserExplain.vue?vue&type=script&lang=js"
export * from "./UserExplain.vue?vue&type=script&lang=js"
import style0 from "./UserExplain.vue?vue&type=style&index=0&id=98136f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98136f86",
  null
  
)

export default component.exports